<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>
    <path d="M9 12L15 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M9 12L15 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" transform="rotate(90 12 12)"/>
  </svg>
</template>
